import React from 'react';
import { Link } from 'react-router-dom';
import './CalculatorsList.css';

function CalculatorsList() {
  const calculators = [
    { name: 'Bhagyank Calculator', path: '/bhagyank-calculator' },
    { name: 'Moolank Calculator', path: '/moolank-calculator' },
    { name: 'Lucky Number Calculator', path: '/lucky-number-calculator' },
    { name: 'Name Numerology Calculator', path: '/name-numerology-calculator' },
    { name: 'Destiny Number Calculator', path: '/destiny-number-calculator' },
    { name: 'Life Path Number Calculator', path: '/life-path-number-calculator' },
    { name: 'Personal Year Number Calculator', path: '/personal-year-number-calculator' },
    { name: 'Mobile Number Compatibility Calculator', path: '/mobile-number-compatibility-calculator' },
    { name: 'Car Number Luck Checker', path: '/car-number-luck-checker' },
    { name: 'Business/Startup Name Numerology Calculator', path: '/business-startup-name-numerology-calculator' },
    { name: 'Marriage Compatibility Calculator', path: '/marriage-compatibility-calculator' },
    { name: 'Financial Luck Calculator', path: '/financial-luck-calculator' },
    { name: 'Health Number Calculator', path: '/health-number-calculator' },
    { name: 'Angel Number Meaning Checker', path: '/angel-number-meaning-checker' },
    { name: 'Chaldean Numerology Calculator', path: '/chaldean-numerology-calculator' },
    { name: 'Birth Date Strength Analyzer', path: '/birth-date-strength-analyzer' },
    { name: 'Name Change Suggestion Calculator', path: '/name-change-suggestion-calculator' },
    { name: 'Career Number Calculator', path: '/career-number-calculator' },
    { name: 'Phone Number Change Recommendation', path: '/phone-number-change-recommendation' },
    { name: 'Startup Name Generator with Score', path: '/startup-name-generator-with-score' },
    { name: 'Planetary Influence Score', path: '/planetary-influence-score' },
    { name: 'Daily Lucky Number Generator', path: '/daily-lucky-number-generator' },
    { name: 'Lucky Dates for Events', path: '/lucky-dates-for-events' },
    { name: 'Mobile Number Analysis', path: '/mobile-number-analysis' },
    { name: 'Vehicle/Car Number Analysis', path: '/vehicle-car-number-analysis' },
    { name: 'House Number Analysis', path: '/house-number-analysis' },
    { name: 'Company Name Compatibility', path: '/company-name-compatibility' },
    { name: 'Signature Numerology', path: '/signature-numerology' },
    { name: 'Lucky Gems & Colors Suggestion', path: '/lucky-gems-colors-suggestion' },
    { name: 'Numerology Report Generator', path: '/numerology-report-generator' },
    { name: 'Startup Name Analysis', path: '/startup-name-analysis' },
    { name: 'Business Name Analysis', path: '/business-name-analysis' },
    { name: 'Brand Name Success Predictor', path: '/brand-name-success-predictor' },
    { name: 'Partnership Compatibility Tool', path: '/partnership-compatibility-tool' },
    { name: 'Astrology-Powered Business Launch Date Finder', path: '/astrology-powered-business-launch-date-finder' },
    { name: 'Logo Numerology Analyzer', path: '/logo-numerology-analyzer' },
  ];

  return (
    <div className="calculators-list container my-8">
      <h1 className="text-center text-primary">Our Calculators</h1>
      <p className="text-center">Explore our wide range of astrology and numerology calculators.</p>

      <div className="calculator-grid">
        {calculators.map((calculator, index) => (
          <Link to={calculator.path} key={index} className="calculator-card shadow-md rounded-lg">
            <h3>{calculator.name}</h3>
            <p>Calculate your {calculator.name.toLowerCase().replace(' calculator', '').replace(' checker', '').replace(' with score', '').replace(' analyzer', '').replace(' recommendation', '').replace(' meaning', '').replace(' score', '')}.</p>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default CalculatorsList;
